import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Loading from '../../../../../components/Loading';
import { toFixed } from '../../../../../helpers/rangeNumber';

class Boxes extends Component {
    constructor() {
        super();
        this.isDark = JSON.parse(localStorage.getItem('dark-mode'));
    }

    render() {
        const { t } = this.props;

        return (
            <div className="ai-tracking-boxes">
                <div className="ai-tracking-boxes-item">
                    <div className="ai-tracking-boxes-item-img">
                        <img
                            src={
                                this.isDark
                                    ? '/static/img/speedometer-03-dark.svg'
                                    : '/static/img/speedometer-03.svg'
                            }
                        />
                    </div>
                    <div className="ai-tracking-boxes-item-body">
                        <div className="ai-tracking-boxes-item-body-title">
                            {t('ai_tracking.boxes.citiation_share')}
                        </div>
                        <div className="ai-tracking-boxes-item-body-value">
                            {this.props.citiationShare || this.props.citiationShare === 0 ? (
                                `${toFixed(this.props.citiationShare)}%`
                            ) : (
                                <Loading onlyPreloader />
                            )}
                        </div>
                    </div>
                </div>
                <div className="ai-tracking-boxes-item">
                    <div className="ai-tracking-boxes-item-img">
                        <img
                            src={
                                this.isDark
                                    ? '/static/img/pie-chart-dark.svg'
                                    : '/static/img/pie-chart-02.svg'
                            }
                        />
                    </div>
                    <div className="ai-tracking-boxes-item-body">
                        <div className="ai-tracking-boxes-item-body-title">
                            {t('ai_tracking.boxes.brand_mention_share')}
                        </div>
                        <div className="ai-tracking-boxes-item-body-value">
                            {this.props.ownBrandMentions || this.props.ownBrandMentions === 0 ? (
                                `${toFixed(this.props.ownBrandMentions)}%`
                            ) : (
                                <Loading onlyPreloader />
                            )}
                        </div>
                    </div>
                </div>
                <div className="ai-tracking-boxes-item">
                    <div className="ai-tracking-boxes-item-img">
                        <img src="/static/img/face-smile.svg" />
                    </div>
                    <div className="ai-tracking-boxes-item-body">
                        <div className="ai-tracking-boxes-item-body-title">
                            {t('ai_tracking.boxes.sentiment')}
                        </div>
                        <div className="ai-tracking-boxes-item-body-value">
                            {this.props.ownSentiment || this.props.ownSentiment === 0 ? (
                                toFixed(this.props.ownSentiment)
                            ) : (
                                <Loading onlyPreloader />
                            )}
                        </div>
                    </div>
                </div>
                <div className="ai-tracking-boxes-item">
                    <div className="ai-tracking-boxes-item-img">
                        <img src="/static/img/bar-chart-11.svg" />
                    </div>
                    <div className="ai-tracking-boxes-item-body">
                        <div className="ai-tracking-boxes-item-body-title">
                            {t('ai_tracking.boxes.rank')}
                        </div>
                        <div className="ai-tracking-boxes-item-body-value">
                            {this.props.ownRank || this.props.ownRank === 0 ? (
                                `#${this.props.ownRank}`
                            ) : (
                                <Loading onlyPreloader />
                            )}
                        </div>
                    </div>
                </div>
                <div className="ai-tracking-boxes-item">
                    <div className="ai-tracking-boxes-item-img">
                        <img
                            src={
                                this.isDark
                                    ? '/static/img/bar-line-chart-dark.svg'
                                    : '/static/img/bar-line-chart.svg'
                            }
                        />
                    </div>
                    <div className="ai-tracking-boxes-item-body">
                        <div className="ai-tracking-boxes-item-body-title">
                            {t('ai_tracking.boxes.ai_citation_avg_position')}
                        </div>
                        <div className="ai-tracking-boxes-item-body-value">
                            {this.props.ownAvgPosition || this.props.ownAvgPosition === 0 ? (
                                toFixed(this.props.ownAvgPosition)
                            ) : (
                                <Loading onlyPreloader />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Boxes);
